<template>
    <transition name="slide-right">
        <v-btn
            id="v-backtop"
            class="icon-btn big"
            v-if="isShow"
            @click="back_top"
        >
            <v-icon>mdi-chevron-up</v-icon>
        </v-btn>
    </transition>
</template>

<script>
import { throttle } from "@/utils/throttle.js";
export default {
    name: "v-backtop",
    data() {
        return {
            isShow: false
        };
    },
    mounted() {
        this.show_hide();
    },
    methods: {
        show_hide() {
            let update_state = () => {
                let winHeight = window.innerHeight;
                let winScrollTop =
                    window.pageYOffset || document.documentElement.scrollTop;
                this.isShow = winHeight * 1.3 < winScrollTop ? true : false;
            };
            window.addEventListener(
                "scroll",
                throttle(update_state, 200, false),
                false
            );
        },
        back_top() {
            $("html, body").animate(
                {
                    scrollTop: 0
                },
                200
            );
        }
    },
    beforeDestroy() {}
};
</script>

<style lang="scss">
#v-backtop {
    overflow: hidden;
    background: $color-white;
    bottom: 110px;

    &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        z-index: 0;
        opacity: 1;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        background-color: transparent;
        transform: scale(0);
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    }

    &:hover {
        &::before {
            transform: scale(1);
            background-color: #1a73e8;
        }

        i {
            color: $color-white;
        }
    }

    i {
        color: #1a73e8;
        font-size: 34px;
    }
}
</style>
